export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11469.3c597678.jpg";